<div class="wd-100">
  <img [src]="images.PINE_LAB_TIMEOUT" class="wd-100" alt="image" />
    <div class="flex-center flex_column p-b-13">
    <div class="fs-23 fw-600 m-t-10 black-clr">{{'SHARED.TIME_OUT' | fallbackTranslate}}</div>
    <div class="m-t-10 p-l-40 p-r-40 ta_center">{{'SHARED.TIME_OUT_TEXT' | fallbackTranslate}}</div>
    <div class="flex-center flex_column m-t-5 p-l-10 p-r-10 wd-100">
      <div class="flex flex_row wd-100 align_center"><div class="wd-50 mleft-vw">{{'SHARED.AMOUNT' | fallbackTranslate}}</div> <div class="wd-50 fs-18 fw-600 black-clr">{{currency}} {{amount.toFixed(2)}}</div></div>
    </div>  
    <div class="wd-100 flex flex_row flex_sb m-t-15 p-l-25 p-r-25">
      <div class="btn-cls flex-center fw-600 yes-cancel" nzType="primary" nzGhost  (click)="submit(PineLabsTimeOut.CANCEL)">
        {{'SHARED.CANCEL' | fallbackTranslate}}
      </div>
      <div class="btn-cls flex-center fs-16 fw-600 no-continue" nzType="primary" (click)="submit(PineLabsTimeOut.RETRY)" >
        {{'SHARED.RETRY' | fallbackTranslate}}
      </div>
    </div>
    </div>
  </div>